<template>
  <BaseCustomizeMetal componentCode="F" />
</template>
<script>
import BaseCustomizeMetal from "@/components/customizeMetal/traditionalMetal/BaseCustomizeMetal/index.vue";
export default {
  name: "CustomizeMetalF",
  components: {
    BaseCustomizeMetal,
  },
};
</script>
<style scoped lang="scss">
::v-deep {
  .metal-text {
    top: 77px;
    left: 140px;
    @include betweenTableTablePro {
      top: 47px;
      left: 90px;
    }
    @include table {
      top: 32px;
      left: 64px;
    }
    @include phone {
      top: 22px;
      left: 49px;
    }
  }
  .templeName {
    height: 31px;
    width: 163px;
    .textContainer {
      width: 165px;
    }
  }
  .godName {
    width: 189px;
    height: 60px;
    .textContainer {
      width: 191px;
    }
  }
  .gift {
    width: 223px;
    height: 40px;
    .textContainer {
      width: 225px;
    }
  }
}
</style>
